export const mediaBuckets: Record<string, any> = {
  "eu-dev": `https://cdn.newgra.ph`,
  "eu-sit": `https://cdn.newgra.ph`,
  "eu-prod": `https://cdn.newgra.ph`,
};
